import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 29,
	viewBox: "0 0 28 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.632 27.456L7.81863 21.168L13.6921 14.9293C13.8347 14.776 13.8279 14.5373 13.6746 14.3933C13.5239 14.252 13.2839 14.2587 13.1413 14.4107L7.28139 20.636L1.16667 17.8267L25.8693 2.05871L10.632 27.456ZM27.2827 0.605324C27.1574 0.48399 26.964 0.464043 26.816 0.55871L0.17735 17.5627C0.0600168 17.6373 -0.00538946 17.768 0.00261054 17.9066C0.0132772 18.044 0.0973293 18.1667 0.222663 18.224L7.08399 21.376L10.2374 28.4267C10.2947 28.5547 10.42 28.6413 10.56 28.6493L10.5827 28.6506C10.716 28.6506 10.8373 28.5813 10.9066 28.4667L27.3427 1.07199C27.4347 0.921324 27.4094 0.727991 27.2827 0.605324Z",
		fill: "#272525"
	})
});
export { SvgSend as ReactComponent };
